export class CoefficientBoost {
    readonly serviceNumber: number;
    readonly boost: number;

    constructor(serviceNumber: number, boost: number) {
        this.serviceNumber = serviceNumber;
        this.boost = boost;
    }

}